export { default as IndexTable } from './IndexTable';
